import expiringConsignmentIcon from './expiringConsignment/icon.jpg';
import expiringConsignmentBanner from './expiringConsignment/new-banner.png';
import newConsignmentBanner from './newConsignment/banner.png';
import newConsignmentIcon from './newConsignment/icon.png';

const expiringConsignmentImages = {
  banner: expiringConsignmentBanner,
  icon: expiringConsignmentIcon,
};

const newConsignmentImages = {
  banner: newConsignmentBanner,
  icon: newConsignmentIcon,
};

export { newConsignmentImages, expiringConsignmentImages };
